module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/83aad438a547a9dfd34794368ac3b643.png";